import moment from "moment";

export class ItCacheService {
  constructor ($log, $q, $interval) {
    'ngInject';
    this.cache = {};
    this.intervals = {};
    this.$q = $q;
    this.$interval = $interval;
  }

  clear() {
    delete this.cache;
    this.cache = {};
    Object.keys(this.intervals).forEach(key => {
      this.$interval.cancel(this['interval_' + key]);
    });
    this.intervals = {};
  }

  clearSpecific(key) {
    delete this.cache[key];
    this.$interval.cancel(this['interval_' + key]);
    delete this.intervals[key];
  }

  get(key, calculate, time = 60000, disableInterval = false) {
    var isFound = this.cache[key] != undefined;
    var value = isFound && this.cache[key].value;
    var isExpired = !isFound || this.cache[key].expiresAt <  moment().toDate().getTime();
    var defer = this.$q.defer();

    var recalculate = (id, f, t, q) => {
      var val = f();
      if(val.then){
        val.then((success) => {
          this.cache[id] = {};
          this.cache[id].value = success;
          this.cache[id].expiresAt =  moment().toDate().getTime() + t;
          q.resolve(this.cache[id].value);
        }, (error) => {
          q.reject(error);
        });
      } else {
        q.resolve(val);
      }
    };

    if(!isFound) {
      recalculate(key, calculate, time, defer);
      if (!this['interval_' + key] && !disableInterval) {
        this['interval_' + key] = this.$interval(() => recalculate(key, calculate, time, defer), time);
        this.intervals[key] = true;
      }
    }
    if(isFound && isExpired) {
      recalculate(key, calculate, time, defer);
      // defer.resolve(value);
    }
    if(isFound && !isExpired) {
      defer.resolve(value);
    }
    return defer.promise;
  }


}

